export function toTitleCase(value) {
    if (typeof value !== 'string') return value ?? '';
    return value.toLocaleLowerCase().replace(
        /(^|[\s\-/'(])(\p{L})/gu,
        (_, sep, ch) => sep + ch.toLocaleUpperCase(),
    );
}
